module.exports = __webpack_public_path__ + "img/bj.33c99157.svg";